import ServiceApi from '@/service/serviceV2.api';
import { AxiosRequestConfig } from 'axios';

export interface QueryOptions {
	params?: { [key: string]: unknown };
	headers?: AxiosRequestConfig['headers'];
	data?: unknown;
}

export interface argsInterface {
	queryKey: [
		string,
		'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE',
		string,
		QueryOptions?,
	];
}

export const apiCallerV2 = async <T>(args: argsInterface): Promise<T> => {
	const [, method, url, options] =
		(args?.queryKey as argsInterface['queryKey']) ?? args; // Explicit type assertion
	const axiosInstance = ServiceApi.getInstance('OS');

	const config: AxiosRequestConfig = {
		method,
		url,
		headers: {},
	};

	if (options) {
		if (options.params) {
			config.params = options.params;
		}
		config.headers = {
			...config.headers,
			...(options.headers || {}),
		};
		if (options.data) {
			config.data = options.data;
			if (options.data instanceof FormData) {
				delete config.headers['Content-Type'];
			} else {
				config.headers['Content-Type'] = 'application/json';
			}
		}
	}

	const response = await axiosInstance.Axios(url, config);
	return (response.data.data || response.data) as T;
};
